import React from "react"
import { Col, Container, Input, Row } from "reactstrap"

const SpecialInstructions = () => {
  return (
    <Container fluid>
      <h5 className="fw-medium my-3">Special Instructions</h5>

      <div className="bg-white p-1">
        <div className="m-1 p-3" style={{ border: "2px solid #D9D9D9" }}>
          <div className="d-flex gap-3 align-items-center">
            <div>Allow customers to Add Special Instructions:</div>
            <div>
              <Input type="checkbox" />
            </div>
          </div>

          <Row className="g-0 mt-2 align-items-center">
            <Col sm='12' lg="3">Instruction Type:</Col>
            <Col sm='12' lg="4">
              <Input type="text" placeholder="Handle with care" />
            </Col>
          </Row>
          <Row className="g-0 mt-2 align-items-center">
            <Col sm='12' lg="3">Additional Price:</Col>
            <Col sm='12' lg="4">
              <Input type="number" placeholder="Price" />
            </Col>
          </Row>
        </div>
      </div>
    </Container>
  )
}

export default SpecialInstructions
